// extracted by mini-css-extract-plugin
export default {"icon":"EditIcon_icon__7ThK1"};